export const tourFermentationMock = {
  id: '632acdb7228e167cf5cc5fe0',
  user: '62e82c5f31eb01fdd8d91d24',
  parent: null,
  email: 'demo@oculyze.net',
  name: 'BB Demo Curve',
  desc: '',
  app_version: '2.5.1',
  backend_version: '0.30.28',
  state: 4,
  method: 30,
  method_attributes: {},
  dilution_sample: 1.0,
  dilution_sample_1: 1.0,
  dilution_sample_2: 0.0,
  dilution_stain: 0.5,
  dilution_stain_1: 1.0,
  dilution_stain_2: 1.0,
  image_volume: 2.8e-6,
  created_at: 'Wed, 21 Sep 2022 08:39:19 GMT',
  created_locally_at: '',
  modified_at: 'Wed, 21 Sep 2022 08:39:19 GMT',
  result_stat: {},
  density: 0.0,
  temperature: 0.0,
  turbidity: 0.0,
  fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
  scale_type: 0,
  oculyze_app_id: 2,
  tags: {
    tag: {
      tank: ['3'],
      yeast_brand: ['Oculyze'],
      yeast_generation: ['5'],
      yeast_strain: ['MTZ14'],
    },
    lang: 'en',
  },
  tasks: [],
  user_correction_enabled: true,
  is_favourite: false,
  favourite_reference: null,
};
